const biller = {
    id: `biller-${Math.random()}`,
    title: 'Biller',
    type: 'item',
    url: `/partner/biller`,
    // icon: icons.IconReport,
    breadcrumbs: false,
    // children: transChild,
    role: process.env.REACT_APP_RL_PRTPRFBIL
};

export default biller;